import { Injectable } from '@angular/core';
import {DipRegistrationLoggerService} from '../logger/dip-registration-logger.service';
import {DipRegistrationContextService} from '../dip-registration-context.service';
import {WebMetricsData} from './web-metrics.constants';
import {TranslateService} from '@ngx-translate/core';
import {getWebMetricsData} from './web-metrics-data.map';


@Injectable({
  providedIn: 'root'
})
export class WebMetricsService {
  constructor(
    private readonly logger: DipRegistrationLoggerService,
    private readonly translate: TranslateService,
    private dipRegistrationContextService: DipRegistrationContextService
  ) {}

  submit(data: WebMetricsData): void {
    if (!data.event) {
      this.logger.warn('WebMetricsService: Event type is missing');
      return;
    }

    if (this.dipRegistrationContextService.isMetricsEnabled()) {
      const tmsTags = [];

      if (data && typeof data === 'object') {
        Object.keys(data).forEach((key) => {
          if (key && (data[key] || data[key] === '')) {
            tmsTags[key] = data[key];
          }
        });
      }

      if (!Array.isArray((window as any).tms_tags)) {
        (window as any).tms_tags = [];
      }
      (window as any).tms_tags.push(tmsTags);

      this.logger.debug(`Metrics submitted for event: ${data.event}`, tmsTags);
    }
  }

  submitErrorAndWarningTag(tag: string, errorCode?: string, errorMessage?: string) {
    if (!tag) {
      this.logger.warn('WebMetricsService: tag is missing');
      return;
    }

    if (tag && this.dipRegistrationContextService.isMetricsEnabled()) {
      const selectedTagInformation = getWebMetricsData(tag);
      if (selectedTagInformation) {
        const tmsTag: any = Object.assign({}, this.getInitialWebMetricsContext());

        if (selectedTagInformation && typeof selectedTagInformation === 'object') {
          Object.keys(selectedTagInformation).forEach((key) => {
            if (key && (selectedTagInformation[key] || selectedTagInformation[key] === '')) {
              tmsTag[key] = selectedTagInformation[key];
            }
          });
        }

        if (errorCode) {
          tmsTag.error.code = errorCode;
        }

        if (errorMessage) {
          tmsTag.error.message = errorMessage;
        }

        if (!Array.isArray((window as any).tms_tags)) {
          (window as any).tms_tags = [];
        }
        // set tms data
        (window as any).tms_tags.push(tmsTag);
      }
    }
  }

  getInitialWebMetricsContext(): any {
    return {
      language: `ca-${this.dipRegistrationContextService.getLanguage()}`,
      province: 'all',
      version: this.dipRegistrationContextService.getVersionId(),
      environment: this.dipRegistrationContextService.getEnvironmentId()
    };
  }
}
